// extracted by mini-css-extract-plugin
module.exports = {"page404":"no-match_page404__1YZ0F","title":"no-match_title__39r0s","optContainer":"no-match_optContainer__1UKmv","btn":"no-match_btn__3XHtC"};